import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("path", { d: "M19 5H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zM4 8a1 1 0 011-1h14a1 1 0 011 1v1H4V8zm16 8a1 1 0 01-1 1H5a1 1 0 01-1-1v-5h16v5z" }), /* @__PURE__ */ _jsx("path", { d: "M7 15h4a1 1 0 000-2H7a1 1 0 000 2zM15 15h2a1 1 0 000-2h-2a1 1 0 000 2z" })]
		})
	})
});
export { SvgCreditCard as ReactComponent };
